import Swiper, { Autoplay, Navigation, EffectFade, Pagination } from 'swiper';
import 'swiper/css/navigation';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const init = () => {
  new Swiper('.js-hero-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    allowTouchMove: false,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    pagination: {
      el: '.js-hero-pagination',
      clickable: true,
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
    modules: [Autoplay, EffectFade, Pagination],
  });

  new Swiper('.js-page-content-slider', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    allowTouchMove: true,
    pagination: {
      el: '.js-slider-pagination',
      clickable: true,
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
      },
    },
    modules: [Pagination],
  });

  new Swiper('.js-images-small-slider', {
    slidesPerView: 1,
    loop: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: true,
    spaceBetween: 24,
    pagination: {
      el: '.js-slider-pagination',
      clickable: true,
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
    modules: [Pagination, EffectFade],
  });

  new Swiper('.js-staff-slider', {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    effect: 'slide',
    loop: false,
    allowTouchMove: true,
    spaceBetween: 24,
    pagination: {
      el: '.js-slider-pagination',
      clickable: true,
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
    breakpoints: {
      1024: {
        spaceBetween: 32,
        simulateTouch: false,
      },
    },
    modules: [Pagination],
  });

  new Swiper('.js-image-slider', {
    slidesPerView: 3.5,
    // loop: true,
    spaceBetween: 20,
    // centeredSlides: true,
    navigation: {
      nextEl: '.js-image-slider-button-next',
      prevEl: '.js-image-slider-button-prev',
    },
    modules: [Navigation],
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  new Swiper('.js-full-image-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.js-slider-pagination',
      clickable: true,
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
    modules: [Pagination, EffectFade],
  });

  const projectTypesSlider = new Swiper('.js-project-types-slider', {
    slidesPerView: 'auto',
  });
  const activeElement = document.querySelector('.js-project-types-slider .js-project-type-active');
  if (activeElement) {
    const slideElement = activeElement.closest('.swiper-slide');
    if (slideElement) {
      const slideIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);
      projectTypesSlider.slideTo(slideIndex, 0);
    }
  }

  new Swiper('.js-partners-slider', {
    spaceBetween: 46,
    centeredSlides: true,
    speed: 5000,
    autoplay: {
      delay: 0,
    },
    loop: true,
    slidesPerView: 'auto',
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 2.4,
      },
      767: {
        slidesPerView: 3,
      },
      1024: {
        centeredSlides: false,
        slidesPerView: 5,
      },
    },
    modules: [Autoplay],
  });
};

export default {
  init,
};
